// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VyReU","question":"styles_question__1c_Po","description":"styles_description__eBBdY"};